import { useEffect } from 'react';

/**
 * Invokes `onEscape` when the user presses Escape, unless a descendant already
 * handled the key (`defaultPrevented`) — e.g. a Radix dropdown closing itself.
 * A DOM subscription is an external-system sync and therefore a valid `useEffect`.
 * Pass a stable callback (from `useGoBack`/`useCallback`).
 */
export function useEscapeKey(onEscape: () => void): void {
  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape' && !e.defaultPrevented) onEscape();
    }
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
    };
  }, [onEscape]);
}
